import db from "@/database";

export const getAll = async () => {
  return db.filteredItems.toArray();
};
